import {
  p5 as classMeta,
  ga as VOID,
  o6 as setMetadataFor,
  m6 as objectMeta,
  f7 as Regex,
  x7 as replace,
  x5 as getStringHashCode,
  s9 as THROW_CCE,
  n8 as toByte,
  x8 as toShort,
  s8 as toInt,
  w8 as toLong,
  p8 as toDouble,
  e1 as ArrayList,
  a2 as collectionSizeOrDefault,
  s2 as joinToString,
  h8 as substringBeforeLast,
  p1 as MutableList,
  e6 as isInterface,
  y5 as hashCode,
  s5 as equals,
  j1 as LinkedHashMap,
  q1 as MutableMap,
  a9 as trimMargin,
  t9 as THROW_ISE,
  a1 as Unit_getInstance,
  g9 as Enum,
  j5 as captureStack,
  r9 as RuntimeException,
  n5 as charSequenceLength,
  c8 as startsWith,
  d as RegexOption_MULTILINE_getInstance,
  c as RegexOption_IGNORE_CASE_getInstance,
  a as getKClassFromExpression,
  c4 as toList,
  y9 as ensureNotNull,
  a8 as split,
  h2 as emptyList,
  l7 as drop,
  k7 as dropLast,
  m8 as toBoolean,
  y2 as last,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class JsonValue {
  p4e() {
    throw JsonException.t4e('Object is not a JsonNumber');
  }
  u4e() {
    throw JsonException.t4e('Object is not a JsonNumber');
  }
  v4e() {
    throw JsonException.t4e('Object is not a JsonString');
  }
  w4e() {
    throw JsonException.t4e('Object is not a JsonObject');
  }
  x4e() {
    throw JsonException.t4e('Object is not a JsonArray');
  }
}
class JsonNull extends JsonValue {
  constructor() {
    JsonNull_instance = null;
    super();
    JsonNull_instance = this;
  }
  y4e() {
    return 'null';
  }
  toString() {
    return 'null';
  }
  z4e(indent, increment) {
    return this.y4e();
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    this.a4f_1 = Regex.hb('(?<!\\\\)\\\\b');
    this.b4f_1 = Regex.hb('(?<!\\\\)\\\\f');
    this.c4f_1 = Regex.hb('(?<!\\\\)\\\\n');
    this.d4f_1 = Regex.hb('(?<!\\\\)\\\\r');
    this.e4f_1 = Regex.hb('(?<!\\\\)\\\\t');
  }
  f4f(rawString) {
    return replace(replace(replace(replace(replace(replace(replace(rawString, '\\', '\\\\'), '\b', '\\b'), '\f', '\\f'), '\n', '\\n'), '\r', '\\r'), '\t', '\\t'), '"', '\\"');
  }
  g4f(encodedValue) {
    var tmp$ret$4;
    // Inline function 'kotlin.text.replace' call
    var tmp$ret$3;
    // Inline function 'kotlin.text.replace' call
    var tmp$ret$2;
    // Inline function 'kotlin.text.replace' call
    var tmp$ret$1;
    // Inline function 'kotlin.text.replace' call
    var tmp$ret$0;
    // Inline function 'kotlin.text.replace' call
    var tmp0_replace = this.a4f_1;
    tmp$ret$0 = tmp0_replace.ob(encodedValue, '\b');
    var tmp1_replace = tmp$ret$0;
    var tmp2_replace = this.b4f_1;
    tmp$ret$1 = tmp2_replace.ob(tmp1_replace, '\f');
    var tmp3_replace = tmp$ret$1;
    var tmp4_replace = this.c4f_1;
    tmp$ret$2 = tmp4_replace.ob(tmp3_replace, '\n');
    var tmp5_replace = tmp$ret$2;
    var tmp6_replace = this.d4f_1;
    tmp$ret$3 = tmp6_replace.ob(tmp5_replace, '\r');
    var tmp7_replace = tmp$ret$3;
    var tmp8_replace = this.e4f_1;
    tmp$ret$4 = tmp8_replace.ob(tmp7_replace, '\t');
    var value = replace(replace(tmp$ret$4, '\\"', '"'), '\\\\', '\\');
    return value;
  }
}
class JsonString extends JsonValue {
  constructor(value) {
    Companion_getInstance();
    super();
    this.h4f_1 = value;
  }
  i4f() {
    return Companion_getInstance().f4f(this.h4f_1);
  }
  v4e() {
    return this;
  }
  y4e() {
    return '"' + this.i4f() + '"';
  }
  z4e(indent, increment) {
    return this.y4e();
  }
  toString() {
    return 'JsonString(value=' + this.h4f_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.h4f_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonString))
      return false;
    var tmp0_other_with_cast = other instanceof JsonString ? other : THROW_CCE();
    if (!(this.h4f_1 === tmp0_other_with_cast.h4f_1))
      return false;
    return true;
  }
}
class JsonNumber extends JsonValue {
  constructor(_value) {
    super();
    this.j4f_1 = _value;
  }
  k4f() {
    return toByte(this.j4f_1);
  }
  l4f() {
    return toShort(this.j4f_1);
  }
  md() {
    return toInt(this.j4f_1);
  }
  id() {
    return toLong(this.j4f_1);
  }
  m4f() {
    var tmp$ret$2;
    // Inline function 'kotlin.text.toFloat' call
    var tmp0_toFloat = this.j4f_1;
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = toDouble(tmp0_toFloat);
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  fe() {
    return toDouble(this.j4f_1);
  }
  u4e() {
    return this;
  }
  y4e() {
    return this.j4f_1;
  }
  z4e(indent, increment) {
    return this.y4e();
  }
  toString() {
    return 'JsonNumber(_value=' + this.j4f_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.j4f_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonNumber))
      return false;
    var tmp0_other_with_cast = other instanceof JsonNumber ? other : THROW_CCE();
    if (!(this.j4f_1 === tmp0_other_with_cast.j4f_1))
      return false;
    return true;
  }
}
class JsonBoolean extends JsonValue {
  constructor(value) {
    super();
    this.n4f_1 = value;
  }
  p4e() {
    return this;
  }
  y4e() {
    return '' + this.n4f_1;
  }
  z4e(indent, increment) {
    return this.y4e();
  }
  toString() {
    return 'JsonBoolean(value=' + this.n4f_1 + ')';
  }
  hashCode() {
    return this.n4f_1 | 0;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonBoolean))
      return false;
    var tmp0_other_with_cast = other instanceof JsonBoolean ? other : THROW_CCE();
    if (!(this.n4f_1 === tmp0_other_with_cast.n4f_1))
      return false;
    return true;
  }
}
class JsonArray extends JsonValue {
  constructor() {
    super();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.o4f_1 = tmp$ret$0;
  }
  x4e() {
    return this;
  }
  y4e() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.o4f_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.kotlin.json.JsonArray.toStringJson.<anonymous>' call
      tmp$ret$0 = item.y4e();
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var elements = joinToString(tmp$ret$2, ',');
    return '[' + elements + ']';
  }
  z4e(indent, increment) {
    var tmp0_subject = this.o4f_1.o();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = '[]';
        break;
      case 1:
        var element = this.o4f_1.p(0).z4e(indent + increment, increment);
        return '[ ' + element + ' ]';
      default:
        var tmp$ret$2;
        // Inline function 'kotlin.collections.map' call
        var tmp0_map = this.o4f_1;
        var tmp$ret$1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
        var tmp0_iterator = tmp0_map.u();
        while (tmp0_iterator.h1()) {
          var item = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.kotlin.json.JsonArray.toFormattedJsonString.<anonymous>' call
          tmp$ret$0 = indent + item.z4e(indent + increment, increment);
          tmp0_mapTo.e1(tmp$ret$0);
        }
        tmp$ret$1 = tmp0_mapTo;
        tmp$ret$2 = tmp$ret$1;

        var elements = joinToString(tmp$ret$2, ',\n');
        return '[\n' + elements + '\n' + substringBeforeLast(indent, increment) + ']';
    }
    return tmp;
  }
  p4f(element) {
    var tmp = this.o4f_1;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).e1(element);
    return this;
  }
  hashCode() {
    return hashCode(this.o4f_1);
  }
  equals(other) {
    var tmp;
    if (other instanceof JsonArray) {
      tmp = equals(this.o4f_1, other.o4f_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class JsonObject extends JsonValue {
  constructor() {
    super();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.q4f_1 = tmp$ret$0;
  }
  w4e() {
    return this;
  }
  r4f(key, value) {
    // Inline function 'kotlin.collections.set' call
    var tmp = this.q4f_1;
    var tmp0_set = isInterface(tmp, MutableMap) ? tmp : THROW_CCE();
    tmp0_set.m3(key, value);
    return this;
  }
  y4e() {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.q4f_1;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(tmp0_map.o());
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = tmp0_map.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'net.akehurst.kotlin.json.JsonObject.toStringJson.<anonymous>' call
      tmp$ret$1 = '"' + item.o3() + '":' + item.p3().y4e();
      tmp0_mapTo.e1(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    var elements = joinToString(tmp$ret$3, ',');
    return '{' + elements + '}';
  }
  z4e(indent, increment) {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.q4f_1;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(tmp0_map.o());
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = tmp0_map.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'net.akehurst.kotlin.json.JsonObject.toFormattedJsonString.<anonymous>' call
      tmp$ret$1 = indent + '"' + item.o3() + '" : ' + item.p3().z4e(indent + increment, increment);
      tmp0_mapTo.e1(tmp$ret$1);
    }
    tmp$ret$2 = tmp0_mapTo;
    tmp$ret$3 = tmp$ret$2;
    var elements = joinToString(tmp$ret$3, ',\n');
    return trimMargin('{\n' + elements + '\n' + substringBeforeLast(indent, increment) + '}');
  }
}
class JsonReference extends JsonValue {
  constructor(document, refPath) {
    super();
    this.s4f_1 = document;
    this.t4f_1 = refPath;
  }
  u4f() {
    var tmp0_elvis_lhs = this.s4f_1.w4f_1.u3(this.t4f_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonException.t4e("Reference target not found for path='" + joinToString(this.t4f_1, ',', '/') + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  y4e() {
    var refPathStr = joinToString(this.t4f_1, '/', '/');
    return '{ "' + Json_getInstance().y4f_1 + '" : "' + refPathStr + '" }';
  }
  z4e(indent, increment) {
    return this.y4e();
  }
  toString() {
    return 'JsonReference(document=' + this.s4f_1 + ', refPath=' + this.t4f_1 + ')';
  }
  hashCode() {
    var result = this.s4f_1.hashCode();
    result = imul(result, 31) + hashCode(this.t4f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonReference))
      return false;
    var tmp0_other_with_cast = other instanceof JsonReference ? other : THROW_CCE();
    if (!this.s4f_1.equals(tmp0_other_with_cast.s4f_1))
      return false;
    if (!equals(this.t4f_1, tmp0_other_with_cast.t4f_1))
      return false;
    return true;
  }
}
class ComplexObjectKind extends Enum {
  b4g() {
    return new JsonString('$' + this.ac_1);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.c4g_1 = '$type';
    this.d4g_1 = '$class';
    this.e4g_1 = '$key';
    this.f4g_1 = '$value';
    this.g4g_1 = '$elements';
    this.h4g_1 = '$entries';
  }
}
class JsonDocument {
  constructor(identity) {
    Companion_getInstance_0();
    this.v4f_1 = identity;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.w4f_1 = tmp$ret$0;
    this.x4f_1 = new JsonUnreferencableObject();
  }
  y4e() {
    return this.x4f_1.y4e();
  }
  toString() {
    return 'JsonDocument(identity=' + this.v4f_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.v4f_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonDocument))
      return false;
    var tmp0_other_with_cast = other instanceof JsonDocument ? other : THROW_CCE();
    if (!(this.v4f_1 === tmp0_other_with_cast.v4f_1))
      return false;
    return true;
  }
}
class JsonUnreferencableObject extends JsonObject {
  w4e() {
    return this;
  }
  r4f(key, value) {
    var tmp = super.r4f(key, value);
    return tmp instanceof JsonUnreferencableObject ? tmp : THROW_CCE();
  }
}
class JsonReferencableObject extends JsonObject {
  constructor(document, path) {
    super();
    this.k4g_1 = document;
    this.l4g_1 = path;
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.k4g_1.w4f_1;
    var tmp1_set = this.l4g_1;
    tmp0_set.m3(tmp1_set, this);
  }
  w4e() {
    return this;
  }
  r4f(key, value) {
    var tmp = super.r4f(key, value);
    return tmp instanceof JsonReferencableObject ? tmp : THROW_CCE();
  }
  toString() {
    return 'JsonReferencableObject(document=' + this.k4g_1 + ', path=' + this.l4g_1 + ')';
  }
  hashCode() {
    var result = this.k4g_1.hashCode();
    result = imul(result, 31) + hashCode(this.l4g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonReferencableObject))
      return false;
    var tmp0_other_with_cast = other instanceof JsonReferencableObject ? other : THROW_CCE();
    if (!this.k4g_1.equals(tmp0_other_with_cast.k4g_1))
      return false;
    if (!equals(this.l4g_1, tmp0_other_with_cast.l4g_1))
      return false;
    return true;
  }
}
class JsonException extends RuntimeException {
  static t4e(message) {
    var $this = super.u6(message);
    init_net_akehurst_kotlin_json_JsonException($this);
    return $this;
  }
}
class Json {
  constructor() {
    Json_instance = this;
    this.y4f_1 = '$ref';
  }
  process(jsonString) {
    return (new JsonParser()).x4g(jsonString);
  }
}
class SimpleScanner {
  constructor(input) {
    this.y4g_1 = input;
    this.z4g_1 = 0;
  }
  r2e() {
    return this.z4g_1 < charSequenceLength(this.y4g_1);
  }
  a4h(literal) {
    return startsWith(this.y4g_1, literal, this.z4g_1, false);
  }
  b4h(pattern) {
    return pattern.jb(this.y4g_1, this.z4g_1);
  }
  c4h(literal) {
    var tmp0_this = this;
    tmp0_this.z4g_1 = tmp0_this.z4g_1 + literal.length | 0;
    return literal;
  }
  d4h(pattern) {
    var m = pattern.nb(this.y4g_1, this.z4g_1);
    var tmp0_safe_receiver = m;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qb();
    var lookingAt = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ub()) === this.z4g_1;
    if (lookingAt) {
      var tmp2_safe_receiver = m;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.p3();
      var tmp;
      if (tmp3_elvis_lhs == null) {
        throw JsonParserException.h4h('Should never happen');
      } else {
        tmp = tmp3_elvis_lhs;
      }
      var match = tmp;
      var tmp4_this = this;
      tmp4_this.z4g_1 = tmp4_this.z4g_1 + m.p3().length | 0;
      return match;
    } else {
      throw JsonParserException.h4h('Error scanning for pattern ' + pattern + ' at Position ' + this.z4g_1);
    }
  }
}
class JsonParser {
  constructor() {
    this.m4g_1 = Regex.gb('\\s+', RegexOption_MULTILINE_getInstance());
    this.n4g_1 = Regex.gb('"(?:\\\\?(.|\n))*?"', RegexOption_MULTILINE_getInstance());
    this.o4g_1 = 'null';
    this.p4g_1 = Regex.hb('-?(?:0|[1-9]\\d*)(?:\\.\\d+)?(?:[eE][+-]?\\d+)?');
    this.q4g_1 = Regex.gb('true|false', RegexOption_IGNORE_CASE_getInstance());
    this.r4g_1 = '[';
    this.s4g_1 = ']';
    this.t4g_1 = '{';
    this.u4g_1 = '}';
    this.v4g_1 = ':';
    this.w4g_1 = ',';
  }
  x4g(input) {
    var doc = new JsonDocument('json');
    var tmp$ret$0;
    // Inline function 'kotlin.text.isEmpty' call
    tmp$ret$0 = charSequenceLength(input) === 0;
    if (tmp$ret$0) {
      throw JsonParserException.h4h('Expected Json content but input was empty');
    }
    var scanner = new SimpleScanner(input);
    var path = mutableStackOf([]);
    var nameStack = mutableStackOf([]);
    var valueStack = mutableStackOf([]);
    while (scanner.r2e()) {
      if (scanner.b4h(this.m4g_1)) {
        scanner.d4h(this.m4g_1);
      } else if (scanner.a4h(this.o4g_1)) {
        scanner.c4h(this.o4g_1);
        valueStack.v1a(JsonNull_getInstance());
      } else if (scanner.b4h(this.q4g_1)) {
        var value = scanner.d4h(this.q4g_1);
        valueStack.v1a(new JsonBoolean(toBoolean(value)));
      } else if (scanner.b4h(this.p4g_1)) {
        var value_0 = scanner.d4h(this.p4g_1);
        valueStack.v1a(new JsonNumber(value_0));
      } else if (scanner.b4h(this.n4g_1)) {
        var value_1 = scanner.d4h(this.n4g_1);
        var decoded = Companion_getInstance().g4f(dropLast(drop(value_1, 1), 1));
        valueStack.v1a(new JsonString(decoded));
      } else if (scanner.a4h(this.r4g_1)) {
        scanner.c4h(this.r4g_1);
        path.v1a('0');
        valueStack.v1a(new JsonArray());
        while (scanner.r2e() ? scanner.b4h(this.m4g_1) : false) {
          scanner.d4h(this.m4g_1);
        }
        if (scanner.a4h(this.s4g_1)) {
          scanner.c4h(this.s4g_1);
          path.w1a();
        }
      } else if (scanner.a4h(this.s4g_1)) {
        scanner.c4h(this.s4g_1);
        path.w1a();
        var value_2 = valueStack.w1a();
        var peek = valueStack.o1a();
        if (peek instanceof JsonArray) {
          peek.p4f(value_2);
        } else {
          throw JsonParserException.h4h('Expected an Array but was a ' + getKClassFromExpression(peek));
        }
      } else if (scanner.a4h(this.w4g_1)) {
        scanner.c4h(this.w4g_1);
        path.w1a();
        var value_3 = valueStack.w1a();
        var peek_0 = valueStack.o1a();
        var tmp0_subject = peek_0;
        if (tmp0_subject instanceof JsonArray) {
          peek_0.p4f(value_3);
          path.v1a(peek_0.o4f_1.o().toString());
        } else {
          if (tmp0_subject instanceof JsonObject) {
            var name = nameStack.w1a();
            peek_0.r4f(name, value_3);
          } else {
            throw JsonParserException.h4h('Expected an Array or an Object but was a ' + getKClassFromExpression(peek_0));
          }
        }
      } else if (scanner.a4h(this.t4g_1)) {
        scanner.c4h(this.t4g_1);
        valueStack.v1a(new JsonUnreferencableObject());
        while (scanner.r2e() ? scanner.b4h(this.m4g_1) : false) {
          scanner.d4h(this.m4g_1);
        }
        if (scanner.a4h(this.u4g_1)) {
          scanner.c4h(this.u4g_1);
        }
      } else if (scanner.a4h(this.u4g_1)) {
        scanner.c4h(this.u4g_1);
        path.w1a();
        var value_4 = valueStack.w1a();
        var peek_1 = valueStack.o1a();
        if (peek_1 instanceof JsonObject) {
          var name_0 = nameStack.w1a();
          peek_1.r4f(name_0, value_4);
          if (1 === peek_1.q4f_1.o() ? peek_1.q4f_1.r3(Json_getInstance().y4f_1) : false) {
            var refStr = ensureNotNull(peek_1.q4f_1.u3(Json_getInstance().y4f_1)).v4e().h4f_1;
            var tmp$ret$2;
            // Inline function 'kotlin.text.substring' call
            var tmp$ret$1;
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$1 = refStr;
            tmp$ret$2 = tmp$ret$1.substring(1);
            var refStr1 = tmp$ret$2;
            var tmp;
            var tmp$ret$3;
            // Inline function 'kotlin.text.isEmpty' call
            tmp$ret$3 = charSequenceLength(refStr1) === 0;
            if (tmp$ret$3) {
              tmp = emptyList();
            } else {
              tmp = split(refStr1, ['/']);
            }
            var refPath = tmp;
            var ref = new JsonReference(doc, refPath);
            valueStack.w1a();
            valueStack.v1a(ref);
          } else if (peek_1.q4f_1.r3(Companion_getInstance_0().c4g_1) ? equals(peek_1.q4f_1.u3(Companion_getInstance_0().c4g_1), ComplexObjectKind_OBJECT_getInstance().b4g()) : false) {
            var jPath = toList(path.c29());
            var obj = new JsonReferencableObject(doc, jPath);
            valueStack.w1a();
            obj.q4f_1 = peek_1.q4f_1;
            valueStack.v1a(obj);
          }
        } else {
          throw JsonParserException.h4h('Expected an Object but was a ' + getKClassFromExpression(peek_1));
        }
      } else if (scanner.a4h(this.v4g_1)) {
        scanner.c4h(this.v4g_1);
        var name_1 = valueStack.w1a().v4e().h4f_1;
        nameStack.v1a(name_1);
        path.v1a(name_1);
      } else {
        var tmp_0 = scanner.z4g_1;
        var tmp$ret$5;
        // Inline function 'kotlin.text.substring' call
        var tmp0_substring = scanner.z4g_1;
        var tmp$ret$4;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = input;
        tmp$ret$5 = tmp$ret$4.substring(tmp0_substring);
        throw JsonParserException.h4h('Unexpected character at position ' + tmp_0 + " - '" + tmp$ret$5 + "'");
      }
    }
    doc.x4f_1 = valueStack.w1a();
    return doc;
  }
}
class JsonParserException extends RuntimeException {
  static h4h(message) {
    var $this = super.u6(message);
    init_net_akehurst_kotlin_json_JsonParserException($this);
    return $this;
  }
}
class MutableStack {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.i4h_1 = tmp$ret$0;
  }
  c29() {
    return this.i4h_1;
  }
  v1a(item) {
    this.i4h_1.e1(item);
  }
  o1a() {
    return last(this.i4h_1);
  }
  w1a() {
    return this.i4h_1.a2(this.i4h_1.o() - 1 | 0);
  }
}
//endregion
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new JsonNull();
  return JsonNull_instance;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
var ComplexObjectKind_PRIMITIVE_instance;
var ComplexObjectKind_ENUM_instance;
var ComplexObjectKind_ARRAY_instance;
var ComplexObjectKind_OBJECT_instance;
var ComplexObjectKind_LIST_instance;
var ComplexObjectKind_SET_instance;
var ComplexObjectKind_MAP_instance;
function valueOf(value) {
  switch (value) {
    case 'PRIMITIVE':
      return ComplexObjectKind_PRIMITIVE_getInstance();
    case 'ENUM':
      return ComplexObjectKind_ENUM_getInstance();
    case 'ARRAY':
      return ComplexObjectKind_ARRAY_getInstance();
    case 'OBJECT':
      return ComplexObjectKind_OBJECT_getInstance();
    case 'LIST':
      return ComplexObjectKind_LIST_getInstance();
    case 'SET':
      return ComplexObjectKind_SET_getInstance();
    case 'MAP':
      return ComplexObjectKind_MAP_getInstance();
    default:
      ComplexObjectKind_initEntries();
      THROW_ISE();
      break;
  }
}
var ComplexObjectKind_entriesInitialized;
function ComplexObjectKind_initEntries() {
  if (ComplexObjectKind_entriesInitialized)
    return Unit_getInstance();
  ComplexObjectKind_entriesInitialized = true;
  ComplexObjectKind_PRIMITIVE_instance = new ComplexObjectKind('PRIMITIVE', 0);
  ComplexObjectKind_ENUM_instance = new ComplexObjectKind('ENUM', 1);
  ComplexObjectKind_ARRAY_instance = new ComplexObjectKind('ARRAY', 2);
  ComplexObjectKind_OBJECT_instance = new ComplexObjectKind('OBJECT', 3);
  ComplexObjectKind_LIST_instance = new ComplexObjectKind('LIST', 4);
  ComplexObjectKind_SET_instance = new ComplexObjectKind('SET', 5);
  ComplexObjectKind_MAP_instance = new ComplexObjectKind('MAP', 6);
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function ComplexObjectKind_PRIMITIVE_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_PRIMITIVE_instance;
}
function ComplexObjectKind_ENUM_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_ENUM_instance;
}
function ComplexObjectKind_ARRAY_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_ARRAY_instance;
}
function ComplexObjectKind_OBJECT_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_OBJECT_instance;
}
function ComplexObjectKind_LIST_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_LIST_instance;
}
function ComplexObjectKind_SET_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_SET_instance;
}
function ComplexObjectKind_MAP_getInstance() {
  ComplexObjectKind_initEntries();
  return ComplexObjectKind_MAP_instance;
}
function init_net_akehurst_kotlin_json_JsonException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.s4e_1);
}
var Json_instance;
function Json_getInstance() {
  if (Json_instance === VOID)
    new Json();
  return Json_instance;
}
function init_net_akehurst_kotlin_json_JsonParserException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.g4h_1);
}
function mutableStackOf(elements) {
  var stack = new MutableStack();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = elements.length;
  while (inductionVariable < last) {
    var element = elements[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'net.akehurst.kotlin.json.mutableStackOf.<anonymous>' call
    stack.v1a(element);
  }
  return stack;
}
//region block: post-declaration
setMetadataFor(JsonValue, 'JsonValue', classMeta);
setMetadataFor(JsonNull, 'JsonNull', objectMeta);
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(JsonString, 'JsonString', classMeta);
setMetadataFor(JsonNumber, 'JsonNumber', classMeta);
setMetadataFor(JsonBoolean, 'JsonBoolean', classMeta);
setMetadataFor(JsonArray, 'JsonArray', classMeta);
setMetadataFor(JsonObject, 'JsonObject', classMeta);
setMetadataFor(JsonReference, 'JsonReference', classMeta);
setMetadataFor(ComplexObjectKind, 'ComplexObjectKind', classMeta);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(JsonDocument, 'JsonDocument', classMeta);
setMetadataFor(JsonUnreferencableObject, 'JsonUnreferencableObject', classMeta);
setMetadataFor(JsonReferencableObject, 'JsonReferencableObject', classMeta);
setMetadataFor(JsonException, 'JsonException', classMeta);
setMetadataFor(Json, 'Json', objectMeta);
setMetadataFor(SimpleScanner, 'SimpleScanner', classMeta);
setMetadataFor(JsonParser, 'JsonParser', classMeta);
setMetadataFor(JsonParserException, 'JsonParserException', classMeta);
setMetadataFor(MutableStack, 'MutableStack', classMeta);
//endregion
//region block: exports
export {
  ComplexObjectKind_ARRAY_getInstance as a,
  ComplexObjectKind_ENUM_getInstance as b,
  ComplexObjectKind_LIST_getInstance as c,
  ComplexObjectKind_MAP_getInstance as d,
  ComplexObjectKind_OBJECT_getInstance as e,
  ComplexObjectKind_PRIMITIVE_getInstance as f,
  ComplexObjectKind_SET_getInstance as g,
  Companion_getInstance_0 as h,
  JsonNull_getInstance as i,
  Companion_getInstance as j,
  Json_getInstance as k,
  JsonArray as l,
  JsonBoolean as m,
  valueOf as n,
  JsonDocument as o,
  JsonNull as p,
  JsonNumber as q,
  JsonObject as r,
  JsonReferencableObject as s,
  JsonReference as t,
  JsonString as u,
  JsonUnreferencableObject as v,
  JsonValue as w,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlin.json-json.mjs.map
